import {InjectionToken} from "@angular/core";

export interface Company {
  companyId: string;
  companyName: string;
}

export interface CompanyService {
  getCompanies(): Company[] | undefined;
}

export const COMPANY_SERVICE = new InjectionToken<Company>('Company service for libs');
